<template>
  <body>
    <Header></Header>
    <img src="inline.png" class="logo" height="50px" width="50px" />
    <span class="title">Leading Content</span>
    <div class="part">
      <!--TV vs Movie-->
      <div id="text3">
        <h1>Which is the leading content ?</h1>
        <h2>Movie 🤼 TV Show</h2>
      </div>
      <div id="svginline">
        <svg
          id="inline"
          style="background-color: #272727"
          width="960"
          height="600"
        ></svg>
      </div>
    </div>
    <router-link to="/responsive" @click.native="scrollToTop">
      <div class="next">
        <img src="next.png" height="50px" width="50px" />
      </div>
    </router-link>
  </body>
</template>

<script>
import * as d3 from "d3";
import Header from "@/components/Header";
export default {
  name: "line_chart",
  components:{
      Header
  },
  data: function () {
    return {
      movie_tv: null,
    };
  },
  mounted: function () {
    if (!this.$store.state.movie_tv) {
      d3.csv("movie_tv.csv", (d) => {
        return {
          year: d.year,
          movie: +d.movie,
          tv: +d.tv,
        };
      }).then((data) => {
        this.movie_tv = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("movie_tv", this.movie_tv);

        this.inline();
      });
    } else {
      this.movie_tv = this.$store.state.movie_tv;
      //console.log("chartData set from store");
      //console.log("chartData contains", this.sunburst_data.length, "rows");
      this.inline();
    }
  },
  methods: {
      scrollToTop() {
      window.scrollTo(0, 0);
    },
    inline() {
      var margin = { top: 20, right: 30, bottom: 30, left: 60 },
        width = 960 - margin.left - margin.right,
        height = 600 - margin.top - margin.bottom;

      // append the svg object to the body of the page
      var svg4 = d3.select("#inline");

      var data = this.movie_tv;

      //divide data into two groups: two line
      var series = data.columns
        .slice(1)
        .map((key) =>
          data.map(({ [key]: value, year }) => ({ key, year, value }))
        );

      var xAxis = (g) =>
        g.attr("transform", `translate(0,${height - margin.bottom})`).attr('color','white').call(
          d3
            .axisBottom(x)
            .ticks(width / 80)
            .tickSizeOuter(0)
            .tickFormat(d3.format("d"))
            
        );

      var x = d3
        .scaleUtc()
        // .scaleBand()
        // .domain([data[0].year, data[data.length - 1].year])
        .domain(d3.extent(data, d => d.year))
        .range([margin.left, width - margin.right]);
    // console.log(x(data[2].year))
      var y = d3
        .scaleLinear()
        .domain([0, d3.max(series, (s) => d3.max(s, (d) => d.value))])
        .range([height - margin.bottom, margin.top]);

      var z = d3.scaleOrdinal(data.columns.slice(1), d3.schemeCategory10);
      var labelPadding = 6;

      svg4.append("g").call(xAxis);

      const serie = svg4.append("g").selectAll("g").data(series).join("g");

      //line path
      serie
        .append("path")
        .attr("fill", "none")
        .attr("stroke", (d) => z(d[0].key))
        .attr("stroke-width", 2.5)
        .attr(
          "d",
          d3
            .line()
            .x((d) => x(d.year))
            .y((d) => y(d.value))
        );

      serie
        .append("g")
        .attr("font-family", "sans-serif")
        .attr("font-size", 10)
        .attr("stroke-linecap", "round")
        .attr("stroke-linejoin", "round")
        .attr("text-anchor", "middle")
        .selectAll("text")
        // .attr('fill','white')
        .data((d) => d)
        .join("text")
        .text((d) => d.value)
        .attr("dy", "0.35em")
        .attr("x", (d) => x(d.year))
        .attr("y", (d) => y(d.value))
        .call((text) =>
          text
            .filter((d, i, data) => i === data.length - 1)
            .append("tspan")
            .attr("font-weight", "bold")
            .text((d) => ` ${d.key}`)
        )

        .clone(true)
        .lower()
        .attr("fill", "none")
        .attr("stroke", "white")
        .attr("stroke-width", labelPadding);
    },
  },
};
</script>

<style scoped>
h1,
h2,
h3,
h4 {
  /* color: whitesmoke; */
  color:rgba(255, 255, 255, 0.93);
  text-align: center;
}

.title {
  position: absolute;
  color: rgba(255, 255, 255, 0.781);
  font-size: 25px;
  top: 10%;
  left: 19.5%;
}
.logo {
  position: absolute;
  top: 9%;
  left: 15%;
}

body {
  background-color: #121212;
  height: 145vh;
}

#text3 {
  position: absolute;
  left: 15%;
  top: 20%;
  background-color: #272727;
  border-radius: 15px;

  /* margin: auto; */
  width: 68.5%;
}

#svginline {
  position: absolute;
  width: 70.5%;
  top: 38%;
  left: 14%;
  display: flex;
  align-items: center;
  /* margin-bottom:20px; */
}

#inline {
  margin: 0 auto;
  display: block;
  border-radius: 15px;
}

.next {
  position: absolute;
  left: 48%;
  top: 128%;
}
</style>